export enum HeaderType {
  MAIN = 'main',
  SESSION = 'session',
}

export enum Boards {
  dragLine = 'DragLine',
  computerVision = 'ComputerVision',
}
